import { Component } from 'react'

import PropTypes from 'prop-types'

import { Modal, Radio } from 'components/Core'

import messages from './UpdateOrderPricingModal.messages'
import styles from './UpdateOrderPricingModal.module.css'

export const UPDATE_ALL_ORDERS = 1
export const UPDATE_SELECTED_ORDERS = 2

class UpdateOrderPricingModal extends Component {
  state = { updateMode: UPDATE_ALL_ORDERS }

  setUpdateMode = (updateMode) => {
    this.setState({ updateMode })
  }

  handlePrimaryAction = () => {
    const { updateMode } = this.state

    if (updateMode === UPDATE_ALL_ORDERS) {
      this.updateAllOrders()
    } else {
      this.updateSelectedOrders()
    }
  }

  updateAllOrders = () => {
    const { handleUpdateOrderPricingByFilters, renderSuccessNotification } =
      this.props
    handleUpdateOrderPricingByFilters().then(() => {
      renderSuccessNotification(messages.enqueuedTask)
    })
  }

  updateSelectedOrders = () => {
    const {
      client,
      handleUpdateOrderPricingByIds,
      handleResetOrder,
      renderActionsToasterMessage,
    } = this.props

    handleUpdateOrderPricingByIds().then(
      ({ data: { bulkUpdateOrderPricingByIds } }) => {
        renderActionsToasterMessage(
          bulkUpdateOrderPricingByIds.updatedOrdersCount,
          bulkUpdateOrderPricingByIds.notUpdatedOrdersCount,
        )
        handleResetOrder(false)
        client.resetStore()
      },
    )
  }

  renderUpdateModeSelection = () => {
    const { selectedOrderIds, totalCount } = this.props
    const { updateMode } = this.state
    const selectedOrdersIsDisabled = !selectedOrderIds.length

    return (
      <>
        <div className={styles.radioContainer}>
          <Radio
            className={styles.radio}
            checked={updateMode === UPDATE_ALL_ORDERS}
            onClick={(e, { value }) => this.setUpdateMode(value)}
            value={UPDATE_ALL_ORDERS}
          />
          {messages.updateAll(totalCount)}
        </div>
        <div className={styles.radioContainer}>
          <Radio
            className={styles.radio}
            checked={updateMode === UPDATE_SELECTED_ORDERS}
            disabled={selectedOrdersIsDisabled}
            onClick={(e, { value }) => this.setUpdateMode(value)}
            value={UPDATE_SELECTED_ORDERS}
          />
          {messages.updateSelected(
            selectedOrderIds.length,
            selectedOrdersIsDisabled,
          )}
        </div>
      </>
    )
  }

  render() {
    return (
      <Modal
        className={styles.UpdateOrderPricingModal}
        title={messages.title}
        primaryActionLabel={messages.primaryButton}
        primaryActionOnClick={this.handlePrimaryAction}
        open
        onClose={this.props.onClose}
      >
        <p>{messages.confirmation}</p>
        {this.renderUpdateModeSelection()}
      </Modal>
    )
  }
}

UpdateOrderPricingModal.propTypes = {
  selectedOrderIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  handleUpdateOrderPricingByIds: PropTypes.func.isRequired,
  handleUpdateOrderPricingByFilters: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
  handleResetOrder: PropTypes.func.isRequired,
  renderActionsToasterMessage: PropTypes.func.isRequired,
  renderSuccessNotification: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
}

export default UpdateOrderPricingModal
